import { Link } from 'react-router-dom';
import { t } from '@/lib/i18n';
import styles from './DefaultLinks.module.css';

interface Ref {
  id: string;
  name: string;
}

interface DefaultLinksProps {
  positions: Ref[];
  units: Ref[];
}

/**
 * Default Positions / Units chip-list, used on Job Template detail pages and
 * Staff Profile detail (display-only). Each chip is a navigation link to the
 * corresponding Library detail page.
 */
export function DefaultLinks({ positions, units }: DefaultLinksProps) {
  return (
    <div className={styles.wrap}>
      <Row
        label={positions.length === 1 ? t('Default Position') : t('Default Positions')}
        items={positions}
        toPrefix="/library/positions/"
      />
      <Row
        label={units.length === 1 ? t('Default Department') : t('Default Departments')}
        items={units}
        toPrefix="/library/departments/"
      />
    </div>
  );
}

function Row({ label, items, toPrefix }: { label: string; items: Ref[]; toPrefix: string }) {
  return (
    <div className={styles.row}>
      <span className={styles.label}>{label}</span>
      {items.length === 0 ? (
        <span className={styles.empty}>—</span>
      ) : (
        <div className={styles.chips}>
          {items.map((it) => (
            <Link
              key={it.id}
              to={`${toPrefix}${encodeURIComponent(it.id)}`}
              className={styles.chip}
            >
              {it.name}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
